// extracted by mini-css-extract-plugin
module.exports = {"lia-guide-navigation":"GuideBottomNavigation_lia-guide-navigation__NyqRI"};